import {
  post_request
} from '../axiosFun';

//车辆信息
export const get_detail_list = (params) => {
  params = {
    row: {
      vin: params,
    }
  }
  return post_request("/web/carMonitor/detail", params)
}
//车辆故障类型
export const get_fault_number_by_vin = (params) => {
  params = {
    row: {
      vin: params,
    }
  }
  return post_request("/web/fault_number_by_vin", params)
}
//故障记录
export const get_fault_his_by_vin = (params) => {
  params = {
    row: {
      vin: params,
    }
  }
  return post_request("/web/fault_his_by_vin", params)
}
//故障分类
export const get_vin_fault_details_number = (params) => {
  params = {
    row: {
      vin: params.vin,
      equipment_name: params.faultName,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return post_request("/web/vin_fault_details_number", params)
}
//故障详情
export const get_vin_fault_details_number_list = (params) => {
  params = {
    row: {
      vin: params.vin,
      equipment_name: params.equipmentName,
      fault_details: params.faultDetails,
      fault_date: params.faultTime,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/vin_fault_details_number_list", params)
}



// WEBPACK FOOTER //
// ./src/api/faultStatistics/faultStatistics.js